let delTaks = function(id, index) {
    this.f.taks.splice(index, 1);
};
export default delTaks;
